import React, { useEffect, useState } from "react";
import SelectedDatasetElement from "../SelectedDatasetElement";
import { Axis, AxisAssignedArrays, Dataset, DatasetAxis } from "../types";
import "./styles.css";

const DragArea = ({
  selectedDatasetsArr,
  removeDataset,
  enableXAxis,
  showAxisSelection,
  assignToAxis,
}: {
  selectedDatasetsArr: Array<Dataset>;
  removeDataset: any;
  enableXAxis: boolean;
  showAxisSelection: boolean;
  assignToAxis: any;
}) => {
  const [datasetsWithAxis, setDatasetsWithAxis] = useState<Array<DatasetAxis>>([]);
  const [axisArray, setAxisArray] = useState<AxisAssignedArrays>({ none: [], X: [], Y: [] });
  const [fieldXClassName, setFieldXClassName] = useState<string>("empty");
  const [fieldYClassName, setFieldYClassName] = useState<string>("empty");

  const onDragStart = (e: any, id: string) => {
    e.dataTransfer.setData("id", id);
  };

  const onDragOver = (e: any) => {
    e.preventDefault();
  };

  // IF X ASSIGNED SWITCH TO UNASSIGNED OR Y AND ASSIGN ONLY ONE NEW X DATASET.
  const onDrop = (e: any, axis: Axis) => {
    let id = e.dataTransfer.getData("id");
    const dtXIndex = datasetsWithAxis.findIndex((dta) => dta.axis === "X");
    let dts = datasetsWithAxis.map((dt, index) => {
      if (dt.identifier === id && axis !== "X") {
        dt.axis = axis;
      }
      if (axis === "X") {
        if (index === dtXIndex) {
          dt.axis = "Y";
        }
        if (dt.identifier === id) {
          dt.axis = axis;
        }
      }
      return dt;
    });
    setDatasetsWithAxis(dts);
  };

  useEffect(() => {
    const foundXIndex = datasetsWithAxis.findIndex((d) => d.axis === "X");
    const foundYIndex = datasetsWithAxis.findIndex((d) => d.axis === "Y");
    if (foundXIndex !== -1) setFieldXClassName("");
    else setFieldXClassName("empty");
    if (foundYIndex !== -1) setFieldYClassName("");
    else setFieldYClassName("empty");
  }, [datasetsWithAxis]);

  useEffect(() => {
    const updateDatasetsArray = (defaultAxis: Axis) => {
      const updatedArray: Array<DatasetAxis> = selectedDatasetsArr.reduce((res: Array<DatasetAxis>, curr, index) => {
        const foundObjIndex = datasetsWithAxis.findIndex((da) => da.identifier === curr.identifier);
        if (foundObjIndex === -1) {
          if (defaultAxis === "Y" && index === 0) {
            res.push({ ...curr, axis: "X" });
          } else {
            res.push({ ...curr, axis: defaultAxis });
          }
        } else {
          const foundObj = res.find((r) => r.identifier === datasetsWithAxis[foundObjIndex].identifier);
          if (foundObj === undefined) {
            res.push(datasetsWithAxis[foundObjIndex]);
          }
        }
        return res;
      }, []);
      setDatasetsWithAxis(updatedArray);
    };
    updateDatasetsArray("Y");
    /*     //DEFAULT TO None AXIS
    if (!showAxisSelection) {
      updateDatasetsArray("none");
    }
    //MAKE DEFAULT FIRST DATASET TO X, AND OTHERS TO Y AXIS
    else {
      updateDatasetsArray("Y");
    } */
  }, [selectedDatasetsArr]);

  useEffect(() => {
    setAxisArray({ none: [], X: [], Y: [] });
    const tempArr: AxisAssignedArrays = { none: [], X: [], Y: [] };
    datasetsWithAxis.forEach((d) => {
      tempArr[d.axis]?.push(
        <SelectedDatasetElement key={d.identifier} draggable onDragStart={(e: any) => onDragStart(e, d.identifier)}>
          {[d, removeDataset]}
        </SelectedDatasetElement>
      );
      /*  if ((tempArr["X"].length === 0 && d.axis === "X") || d.axis === "Y" || d.axis === "none") {
        tempArr[d.axis].push(
          <SelectedDatasetElement draggable onDragStart={(e: any) => onDragStart(e, d.id)}>
            {[d, removeDataset]}
          </SelectedDatasetElement>
        );
      } else {
        // X axis is assigned -> switch with new element
        if (tempArr["X"].length > 0 && d.axis === "X") {
         tempArr["none"].push(tempArr["X"][0]);
          tempArr["X"][0] = (
            <SelectedDatasetElement draggable onDragStart={(e: any) => onDragStart(e, d.id)}>
              {[d, removeDataset]}
            </SelectedDatasetElement>
          );
        }
      } */
    });
    const xDataset: string = tempArr["X"][0]?.props.children[0].identifier;
    const yDatasets: Array<string> = tempArr["Y"]?.map((y) => y.props.children[0].identifier);
    assignToAxis(xDataset, yDatasets);
    setAxisArray(tempArr);
  }, [datasetsWithAxis]);

  return (
    <>
      <div className="flexRow align-items-center justify-content-left margin">
        {!showAxisSelection && (
          <div className="flexColumn">
            <label htmlFor="dropbox">Selected datasets: </label>
            <div
              className="drop-box"
              id="dropbox"
              onDragOver={(e) => onDragOver(e)}
              onDrop={(e) => {
                onDrop(e, "none");
              }}
            >
              {axisArray.X}
              {axisArray.Y}
              {axisArray.none}
            </div>
          </div>
        )}
        {showAxisSelection && (
          <div className="flexColumn">
            {enableXAxis && (
              <div id="dropbox">
                <label htmlFor="dropboxX">X axis: </label>
                <div className="flexRow align-items-center justify-content-left ">
                  <div
                    className={`drop-box ${fieldXClassName}`}
                    id="dropboxX"
                    onDragOver={(e) => onDragOver(e)}
                    onDrop={(e) => {
                      onDrop(e, "X");
                    }}
                  >
                    {axisArray.X}
                  </div>
                </div>
              </div>
            )}
            <div className="" id="dropbox">
              <label htmlFor="dropboxY">Y axis: </label>
              <div className="flexRow align-items-center justify-content-left">
                <div
                  className={`drop-box ${fieldYClassName}`}
                  id="dropboxY"
                  onDragOver={(e) => onDragOver(e)}
                  onDrop={(e) => {
                    onDrop(e, "Y");
                  }}
                >
                  {axisArray.Y}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default DragArea;
